import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  DialogPosition,
  MatDialog,
  MatTableDataSource
} from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { RouteStatus } from '../../../../@core/models/dto-routestatus';
import { DTOParcelHistory } from '../../../../@core/models/DTOParcelHistory';
import { DTOParcelHistories } from '../../../../@core/models/DTOParcelHistories';
import { DTOParcelInfo } from '../../../../@core/models/DTOParcelInfo';
import {
  DTOShipment,
  ShipmentStatusEnum,
  ShipmentTypeEnum
} from '../../../../@core/models/DTOShipment';
import { DTOStop } from '../../../../@core/models/DTOStop';
import {
  SectorCompress,
  Stop,
  Stops
} from '../../../../@core/models/live-route';
import { LiveRouteType } from '../../../../@core/models/live-route-type';
import { ApiProvider } from '../../../../@core/providers/api.provider';
import { AuthenticationService } from '../../../../@core/services/authentication.service';
import { LocationService } from '../../../../@core/services/location.service';
import { PhotoService } from '../../../../@core/services/photo.service';
import { ShipmentService } from '../../../../@core/services/shipment.service';
import { SignatureService } from '../../../../@core/services/signature.service';
import { StopService } from '../../../../@core/services/stop.service';
import { CrmAddExceptionDialogComponent } from '../dialogs/crm-add-exception-dialog/crm-add-exception-dialog.component';
import { CrmAddressChangeDialogComponent } from '../dialogs/crm-address-change-dialog/crm-address-change-dialog.component';
import { CrmDriverDialogComponent } from '../dialogs/crm-driver-dialog/crm-driver-dialog.component';
import { CrmNewTpslDialogComponent } from '../dialogs/crm-new-tpsl-dialog/crm-new-tpsl-dialog.component';
import { CrmShowPhotosDialogComponent } from '../dialogs/crm-show-photos-dialog/crm-show-photos-dialog.component';
import { Shipping } from '../fake.data';
import { DatePipe } from '@angular/common';
import {
  ConfirmDialogComponent,
  ConfirmDialogModel
} from '../../../../@theme/components/confirm-dialog/confirm-dialog.component';
import { HttpErrorResponse } from '@angular/common/http';
import { DTOException } from '../../../../@core/models/DTOException';
import { CryptoService } from '../../../../@core/services/encrypt.service';

@Component({
  selector: 'crm-board',
  templateUrl: './crm-board.component.html',
  styleUrls: ['./crm-board.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      )
    ])
  ]
})
export class CrmBoardComponent implements OnInit, OnDestroy {
  // shipment: Shipment = SHIPMENT_DATA;
  sub: Subscription;
  shipment: DTOShipment;
  waybill: string;
  userId: string;
  lang: string;
  key: string;
  encryptedKey: string;
  shipping: DTOParcelInfo;
  isNotAuthorized: boolean = false;
  StopsList: Stop[];
  showLoading: boolean;
  displayedShippingColumns: string[] = [
    'select',
    'waybill',
    'parcel',
    'deliveryDate',
    'signature',
    'contact',
    'status',
    'print'
  ];
  shippingDataSource = new MatTableDataSource<DTOParcelInfo>(null);
  shippingSelection = new SelectionModel<DTOParcelInfo>(true, []);
  boolEditNotes: boolean = false;
  noteField: string;

  shippingElement: Shipping | null;

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.shippingSelection.selected.length;
    const numRows = this.shippingDataSource.data.length;
    return numSelected === numRows;
  }

  allRowsExpanded: boolean = false;
  allRowsSelected: boolean = false;
  allNotDeliveredSelected: boolean = false;

  public toggleExpand() {
    this.allRowsExpanded = !this.allRowsExpanded;
    this.shippingElement = null;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.allRowsSelected = !this.allRowsSelected;
    if (this.isAllSelected()) {
      this.shippingSelection.clear();
      return;
    }
    this.shippingSelection.select(...this.shippingDataSource.data);
  }

  openAddressChangeDialog(event, editDestination: boolean): void {
    const dialogPosition: DialogPosition = {
      top: event.y + 'px'
    };
    let lang: string;
    if (this.lang === '1033') {
      lang = 'en';
    } else if (this.lang === '1036') {
      lang = 'fr';
    }
    let height = '400px';
    if (this.shipment.SenderHistory || this.shipment.DestinationHistory) {
      height = '600px';
    }
    const dialogRef = this.dialog.open(CrmAddressChangeDialogComponent, {
      width: '900px',
      height: height,
      position: dialogPosition,
      data: {
        shipment: this.shipment,
        editDestination: editDestination,
        userId: this.userId,
        key: this.key,
        lang: lang
      }
    });

    dialogRef.afterClosed().subscribe((res) => {
      this.loadShipment();
    });
  }

  toggleNotDelivered() {
    this.allNotDeliveredSelected = !this.allNotDeliveredSelected;
    if (!this.allNotDeliveredSelected) {
      this.shippingSelection.clear();
      return;
    }
    this.shippingSelection.select(
      ...this.shippingDataSource.data.filter(
        (parcelInfo) => parcelInfo.Status != 'Delivered'
      )
    );
    // this.shippingDataSource.filter = 'Delivered';
  }

  openDriverDialog(event, destination): void {
    const dialogPosition: DialogPosition = {
      top: event.y - 400 + 'px'
    };
    let lang: string;
    if (this.lang === '1033') {
      lang = 'en';
    } else if (this.lang === '1036') {
      lang = 'fr';
    }
    const dialogRef = this.dialog.open(CrmDriverDialogComponent, {
      width: '700px',
      height: '300px',
      position: dialogPosition,
      data: {
        destination: destination,
        userId: this.userId,
        key: this.key,
        lang: lang
      }
    });
  }

  openPhotosDialog(event): void {
    const dialogPosition: DialogPosition = {
      top: event.y - 500 + 'px'
    };
    let lang: string;
    if (this.lang === '1033') {
      lang = 'en';
    } else if (this.lang === '1036') {
      lang = 'fr';
    }
    const dialogRef = this.dialog.open(CrmShowPhotosDialogComponent, {
      height: '500px',
      width: '800px',
      position: dialogPosition,
      data: {
        parcelId: 0,
        photos: this.shipment.Photos,
        userId: this.userId,
        key: this.key,
        lang: lang
      }
    });
  }

  printParcelLabel(event, parcelId?: number): void {
    event.stopPropagation();
    if (!parcelId) {
      return;
    }

    this.apiProvider.printLabels([parcelId]).subscribe();
  }

  addExceptions(event): void {
    const dialogPosition: DialogPosition = {
      top: event.y + 'px'
    };
    let lang: string;
    if (this.lang === '1033') {
      lang = 'en';
    } else if (this.lang === '1036') {
      lang = 'fr';
    }
    const dialogRef = this.dialog.open(CrmAddExceptionDialogComponent, {
      width: '700px',
      height: '400px',
      data: {
        parcels: this.shippingSelection.selected,
        shipment: this.shipment,
        userId: this.userId,
        key: this.key,
        lang: lang
      }
    });
    dialogRef.afterClosed().subscribe((res: DTOException) => {
      /*for (let parcelInfo of this.shippingDataSource.data) {
        if (this.shippingSelection.selected.includes(parcelInfo)) {
          if (res !== false) {
            parcelInfo.History.unshift(res);
          }
        }
      }*/
      this.loadShipment();
    });
  }

  get liverouteType() {
    return LiveRouteType;
  }

  constructor(
    public _stopService: StopService,
    public dialog: MatDialog,
    public _locationService: LocationService,
    private shipmentService: ShipmentService,
    public _photoService: PhotoService,
    public _authenticationService: AuthenticationService,
    public _translateService: TranslateService,
    public _signatureService: SignatureService,
    private router: Router,
    private datePipe: DatePipe,
    private apiProvider: ApiProvider,
    private route: ActivatedRoute,
    private readonly cryptoService: CryptoService
  ) {
    /*this._authenticationService.currentUserValue.authdata =
      'MzAwMDgxOipOYXRpb25leEludGVybmFsQVBJKg==';*/
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  async ngOnInit() {

    const querystringParams = new URLSearchParams(window.location.search);
    
    this.waybill = querystringParams.get('waybill');
    this.userId = querystringParams.get('userId');
    this.encryptedKey = querystringParams.get('key');

    const decryptedKey = await this.cryptoService.decryptBase64(this.encryptedKey, "let encrypt = this.encryptService.encrypt(chaine);")
    this.key = decryptedKey;
    
    this.lang = querystringParams.get('UserLanguage');
    this.isNotAuthorized = false;
    if (this.waybill === '' || this.waybill === null || !Number(this.waybill))
      this.router.navigateByUrl(
        `/crm/search?userId=${this.userId}&key=${this.encryptedKey}&UserLanguage=${this.lang}`
      );

    if (this.lang === '1033') {
      this._translateService.use('en');
    } else if ((this.lang = '1036')) {
      this._translateService.use('fr');
    }

    if (this._authenticationService.currentUserValue === null) {
      this.apiProvider.GetCRMUser(this.userId, this.key).subscribe((res) => {
        if (res) {
          let user = {
            UserID: this.userId,
            UserName: res
          };

          localStorage.setItem('currentUser', JSON.stringify(user));
          this._authenticationService.setUser(user);
        }
      });
    }

    this.loadShipment();
  }

  loadShipment() {
    this.showLoading = true;
    this.shipmentService
      .GetShipment(Number(this.waybill), this.userId, this.key)
      .subscribe(
        (res) => {
          if (res === null || res === undefined)
            this.router.navigateByUrl(
              `/crm/search?userId=${this.userId}&key=${this.encryptedKey}&UserLanguage=${this.lang}`
            );

          if (res.Sender === null) {
            this.isNotAuthorized = true;
          } else {
            if(res.ConsolShipmentIds.length <= 1){
              res.IsConsolidated = false;
            }
            this.shipment = res;
            this.noteField = this.shipment.Note;
            this.shippingDataSource = new MatTableDataSource<DTOParcelInfo>(
              this.shipment.Parcels
            );
          }
          this.showLoading = false;
        },
        (err: HttpErrorResponse) => {
          if (err.status === 400 || err.status === 404) {
            this.router.navigateByUrl(
              `/crm/search?userId=${this.userId}&key=${this.encryptedKey}&UserLanguage=${this.lang}`
            );
          }
        }
      );
  }

  editNotes() {
    this.boolEditNotes = !this.boolEditNotes;
  }

  saveNotes() {
    this.shipment.Note = this.noteField;
    this.shipmentService
      .UpdateShipment(this.shipment, this.userId, this.key, false)
      .subscribe((res) => {
        this.editNotes();
        this.loadShipment();
      });
  }

  voidException(
    event,
    exceptionId: number,
    processedDate: Date,
    parcelId: number,
    shipping: DTOParcelInfo
  ) {
    const dialogPosition: DialogPosition = {
      top: event.y - 200 + 'px',
      left: event.x + 10 + 'px'
    };

    const message = this._translateService.instant(
      'crm.confirm-void-exception'
    );

    const dialogData = new ConfirmDialogModel('Confirm Action', message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: `400px`,
      position: dialogPosition,
      data: dialogData
    });
    this.shipping = shipping;
    dialogRef.afterClosed().subscribe((res) => {
      let parcelIds: number[] = [];
      if (res) {
        for (let parcel of this.shipment.Parcels) {
          parcelIds.push(parcel.ParcelId);
        }
      } else if (!res) {
        parcelIds.push(parcelId);
      }

      let am = new Date(processedDate).getHours() < 12 ? 'AM' : 'PM';
      let dtoParcelHistories: DTOParcelHistories = {
        ParcelIds: parcelIds,
        ExceptionId: exceptionId,
        ProcessedDate:
          this.datePipe.transform(processedDate, 'yyyy-MM-dd hh:mm:ss') + am
      };
      this.shipmentService
        .VoidException(dtoParcelHistories, this.userId, this.key)
        .subscribe((res) => {
          /*if (parcelIds.length > 1) {
            for (let parcel of this.shipment.Parcels) {
              for (let exception of parcel.History) {
                if (exception.ExceptionId === exceptionId) {
                  exception.DescriptionEn = '(VOID) ' + exception.DescriptionEn;
                  exception.DescriptionFr = '(VOID) ' + exception.DescriptionFr;
                }
              }
            }
          } else {
            for (let exception of this.shipping.History) {
              if (exception.ExceptionId === exceptionId) {
                exception.DescriptionEn = '(VOID) ' + exception.DescriptionEn;
                exception.DescriptionFr = '(VOID) ' + exception.DescriptionFr;
              }
            }
          }*/
          this.loadShipment();
        });
    });
  }

  closeNotes() {
    this.editNotes();
  }

  getBgShipmentType() {
    if (this.shipment.IsCustomerInactive) {
      return 'bg-lightgray';
    } else if (this.shipment.ShipmentStatus === ShipmentStatusEnum.Cancelled) {
      return 'bg-cyan';
    } else if (this.shipment.IsPickup) {
      return 'bg-red';
    } else if (
      this.shipment.ShipmentType == ShipmentTypeEnum.Delivery ||
      this.shipment.ShipmentType == ShipmentTypeEnum.PickupDelivery
    ) {
      return 'bg-yellow';
    } else {
      return '';
    }
  }

  showParcelStatusIcon(status: string) {
    switch (status) {
      case 'Creation':
        return 'build';
      case 'Pickup':
        return 'local_shipping';
      case 'Transit':
        return 'local_shipping';
      case 'OutForDelivery':
        return 'place';
      case 'Delivered':
        return 'done_all';
      case 'OnHold':
        return 'warning';
      case 'Attention':
        return 'warning';
      case 'Cancelled':
        return 'warning';
      case 'ReturnCompleted':
        return 'done_all';
      case 'OutForPickup':
        return 'local_shipping';
      case 'RefusedDelivery':
        return 'warning';
      case 'ReturnToSender':
        return 'warning';
    }
  }

  showParcelStatusClass(status: string) {
    switch (status) {
      case 'Creation':
        return 'blue-icon';
      case 'Pickup':
        return 'purple-icon';
      case 'Transit':
        return 'blue-icon';
      case 'OutForDelivery':
        return 'blue-icon';
      case 'Delivered':
        return 'green-icon';
      case 'OnHold':
        return 'yellow-icon';
      case 'Attention':
        return 'red-icon';
      case 'Cancelled':
        return 'red-icon';
      case 'ReturnCompleted':
        return 'green-icon';
      case 'OutForPickup':
        return 'purple-icon';
      case 'RefusedDelivery':
        return 'red-icon';
      case 'ReturnToSender':
        return 'yellow-icon';
    }
  }
}
